import packageJSON from '../../package.json';

export const environment = {
  production: true,
  configURL: '/assets/configs/prod.json',
  version: packageJSON.version,
};
